export default __webpack_public_path__ + "static/blob10-953c9e665b95b3b018c3d432cbf8ba9b.svg";